import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { RecurringInvoiceCancellation } from "../../models/invoice.model";
import { AlertService } from "../../../core/alert.service";
import { InvoiceService } from "../../services/invoice-service.service";

@Component({
  selector: 'app-subscription-cancellation',
  templateUrl: './subscription-cancellation.component.html',
  styleUrls: ['./subscription-cancellation.component.scss']
})
export class RecurringInvoiceCancellationComponent implements OnInit {
  @Input() recurringInvoiceModel: any;
  @Input() invoiceModel: any;
  @Input() status: string = "For Approval";
  @Input() displayApprovalNotes: boolean = false;

  cancelModel : RecurringInvoiceCancellation;

  reasons: any[] = [];
  loadingcancellationReason: boolean;
  busy: boolean = false;

  constructor(private modalRef: NgbActiveModal,
        private alert: AlertService,
        private invoiceService: InvoiceService,) {
      this.cancelModel = new RecurringInvoiceCancellation();
      this.cancelModel.Id = 0;

    }

  ngOnInit() {
    this.cancelModel.RecurringInvoiceId = this.recurringInvoiceModel.id;
    this.cancelModel.UpdatedBy = this.recurringInvoiceModel.createdBy;
    this.cancelModel.RecurringInvoiceStatus = this.recurringInvoiceModel.status;
    this.cancelModel.Status = this.status;

    this.loadRecurringInvoices();
    this.loadCancellationReasons();
  }

  cancelReasonChanged(id, description){
    this.cancelModel.Reason = description;
  }

  loadRecurringInvoices() {
    this.busy = true;
    this.invoiceService.getRecurringInvoicesByRecurringId(this.recurringInvoiceModel.id).subscribe((res: any) => {
      this.busy = false;
      this.cancelModel.NumberOfInvoices = res.length;
    });
  }

  loadCancellationReasons(){
    this.loadingcancellationReason = true;
    this.invoiceService.getRecurringInvoiceCancellationReasons().subscribe((res:any[])=>{
      this.reasons = res;
      this.loadingcancellationReason = false;
    },(error: any)=>{},()=>{
      this.loadingcancellationReason = false;
    })
  }

  isFormValid(){
    if(!this.cancelModel.CancellationReasonId)
      return false;
    if(!this.cancelModel.Reason)
      return false;

    return true;
  }

  save(){
    if(this.isFormValid()){
      this.invoiceService.upsertRecurringInvoiceCancellation(this.cancelModel)
      .subscribe((res:any)=>{
        if(res){
          this.alert.alertSuccess({ title: 'Success', text: `Your cancellation request has been successfully saved!` });
          this.close(res);
        }
      });
    }
  }

  close(data?: any) {
    this.modalRef.close(data);
  }


}
